import { createRouter, createWebHistory } from 'vue-router'
import DashboardLayout from '../layouts/DashboardLayout.vue';
import { authGuard } from '../utils/authGuard';
import LoginView from '../views/LoginView.vue'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginView,
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem('token');
      if (token) {
        next({ name: 'Dashboard' });
      } else {
        next();
      }
    }
  },
  // Redirects from old /dashboard/* paths to new root paths
  {
    path: '/dashboard/notifications',
    redirect: '/notifications'
  },
  {
    path: '/dashboard/packages',
    redirect: '/packages'
  },
  {
    path: '/dashboard/transactions',
    redirect: '/transactions'
  },
  {
    path: '/dashboard/withdrawal',
    redirect: '/withdrawal'
  },
  {
    path: '/dashboard/loans',
    redirect: '/loans'
  },
  {
    path: '/dashboard/financial-analytics',
    redirect: '/financial-analytics'
  },
  {
    path: '/dashboard/daily-financials',
    redirect: '/daily-financials'
  },
  {
    path: '/dashboard/users',
    redirect: '/users'
  },
  {
    path: '/dashboard/advertisements',
    redirect: '/advertisements'
  },
  {
    path: '/dashboard/account',
    redirect: '/account'
  },
  {
    path: '/dashboard/cards',
    redirect: '/cards'
  },
  {
    path: '/dashboard/fixed-deposits',
    redirect: '/fixed-deposits'
  },
  {
    path: '/dashboard/loan-products',
    redirect: '/loan-products'
  },
  // Main routes
  {
    path: '/dashboard',
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/DashboardView.vue')
      },
    ],
      },
      {
        path: '/notifications',
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'Notifications',
        component: () => import(/* webpackChunkName: "notifications" */ '../views/NotificationView.vue')
      },
    ],
      },
      {
        path: '/packages',
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'Packages',
        component: () => import(/* webpackChunkName: "packages" */ '../views/PackageView.vue')
      },
    ],
      },
      {
        path: '/transactions',
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'Transactions',
        component: () => import(/* webpackChunkName: "transactions" */ '../views/TransactionsView.vue')
      },
    ],
      },
      {
        path: '/withdrawal',
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'Withdrawal',
        component: () => import(/* webpackChunkName: "withdrawal" */ '../views/WithdrawalView.vue')
      },
    ],
      },
      {
    path: '/loans',
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'LoanManagement',
        component: () => import(/* webpackChunkName: "loans" */ '../views/LoanManagementView.vue')
      },
    ],
  },
      {
        path: '/financial-analytics',
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'FinancialAnalytics',
        component: () => import(/* webpackChunkName: "financial-analytics" */ '../views/FinancialAnalyticsView.vue')
      },
    ],
  },
      {
        path: '/daily-financials',
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'DailyFinancials',
        component: () => import(/* webpackChunkName: "daily-financials" */ '../views/DailyFinancialsView.vue')
      },
    ],
  },
      {
        path: '/users',
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'UsersManagement',
        component: () => import(/* webpackChunkName: "users" */ '../views/UsersManagementView.vue')
      },
    ],
  },
  {
    path: '/advertisements',
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'Advertisements',
        component: () => import(/* webpackChunkName: "advertisements" */ '../views/AdvertisementView.vue')
      },
    ],
      },
  {
    path: '/account',
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'Account',
        component: () => import(/* webpackChunkName: "account" */ '../views/AccountSettingsView.vue')
      },
    ],
  },
  {
    path: '/cards',
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'CardManagement',
        component: () => import(/* webpackChunkName: "cards" */ '../views/CardManagementView.vue')
      },
    ],
  },
  {
    path: '/fixed-deposits',
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'FixedDepositManagement',
        component: () => import(/* webpackChunkName: "fixed-deposits" */ '../views/FixedDepositManagementView.vue')
      },
    ],
  },
  {
    path: '/loan-products',
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: '',
        name: 'LoanProductsManagement',
        component: () => import(/* webpackChunkName: "loan-products" */ '../views/LoanProductsManagementView.vue')
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Log router setup for debugging
router.isReady().then(() => {
  console.log('✅ Router ready with', routes.length, 'routes')
})

export default router
